import { render, staticRenderFns } from "./blog_details_left_sidebar.vue?vue&type=template&id=3547e42f"
import script from "./blog_details_left_sidebar.vue?vue&type=script&lang=js"
export * from "./blog_details_left_sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports